<template>
    <v-dialog v-model="dialog" persistent max-width="450">
        <v-card>
            <v-card-text>
                <v-row class="my-0">
                    <v-col cols="12" md="12" class="pb-0 d-flex justify-end">
                        <v-btn icon dark @click="dialog = false">
                            <v-icon color="#37323c" width="10"
                                >mdi-close</v-icon
                            >
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                        cols="12"
                        md="12"
                        class="mb-1 pt-0 d-flex justify-center"
                    >
                        <div>
                            <div class="prompt-title-500">
                                {{ $t('message.qualifiedApplicants.dialog.headerUp')}}<br />{{ $t('message.qualifiedApplicants.dialog.headerBottom')}}
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-form id="type_gen" ref="generators" v-model="form">
                    <Type-Gen
                        v-for="(todo) in input"
                        :key="todo.id"
                        :container_id="todo.id"
                        @remove="removeInput(todo.id)"
                        @updateText="updateTextParent"
                        @updateGenStart="updateTextGenStart"
                    ></Type-Gen>
                </v-form>
                <v-row class="my-0">
                    <v-col cols="12" lg="12" class="d-flex justify-end">
                        <a
                            id="add-type"
                            class="prompt-underline text-decoration-underline"
                            @click="addNewType()"
                        >
                        {{ $t('message.qualifiedApplicants.dialog.add')}}
                        </a>
                    </v-col>
                    <v-col cols="12" lg="12">
                        <v-divider
                            style="border: 0.1px solid #d4d9de"
                        ></v-divider>
                    </v-col>
                    <v-col cols="6" lg="6">
                        <div class="form-label mb-1" hide-details="auto">
                            {{ $t('message.qualifiedApplicants.dialog.example')}}
                        </div>
                        <div class="sarabun-16 my-1 py-1" hide-details="auto">
                            {{ this.test }} {{ this.test2 }} {{ this.test3 }}
                        </div>
                    </v-col>
                </v-row>
                <v-row class="my-0">
                    <v-col cols="12" md="6" class="mb-1">
                        <v-btn
                            class="prompt-title-page"
                            color="#FF9800"
                            block
                            rounded
                            dark
                            @click="dialog = false"
                            outlined
                            height="40"
                            style="font-size: 18px"
                            >{{ $t('message.qualifiedApplicants.cancel')}}</v-btn
                        >
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-btn
                            class="prompt-title-page"
                            color="#FF9800"
                            :disabled="!form"
                            block
                            rounded
                            @click="create_id"
                            height="40"
                            style="color: white;
                        font-weight: 400;
                        font-size: 18px;"
                            >{{ $t('message.qualifiedApplicants.dialog.createId')}}</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import TypeGen from "@/components/fileElement/TypeGen.vue";

export default {
    data() {
        return {
            test: "",
            test2: "",
            test3: "",
            allText: [{
                id: 0,
                mode: "fix",
                text: "",
                text2: "",
                text3: "",
            }],
            selectedOfIndex: 1,
            input_id: 1,
            input: [{ id: 0 }],
            dialog: false,
            form: []
        };
    },
    components: { TypeGen },
    props: {
        dialogBool: Boolean,
    },
    methods: {
        addNewType() {
            if (this.input.length < 5) {
                this.input.push({
                    id: this.input_id,
                });
                this.allText.push({
                    id: this.input_id,
                    mode: "fix",
                    text: "",
                    text2: "",
                    text3: "",
                })
                this.input_id++;
            }
        },
        updateTextParent(txt, index) {
            this.test = "";
            this.test2 = "";
            this.test3 = "";
            let updateTarget = this.allText.findIndex((item) => item.id == index)
            this.allText[updateTarget] = {
                id: this.allText[updateTarget].id,
                mode: "fix",
                text: txt || "",
                text2: txt || "",
                text3: txt || "",
            }
            
            this.renderText();
        },
        updateTextGenStart(digit, num, index) {
            let digitNumber = Math.pow(10, digit);
            let newTxt = "";
            let num2 = parseInt(num) + 1;
            let num3 = parseInt(num) + 2;
            this.test = "";
            this.test2 = "";
            this.test3 = "";

            if (num < digitNumber) {
                newTxt = this.addZero(num, digitNumber);
            }
            
            let updateTarget = this.allText.findIndex((item) => item.id == index)
            let new_val = this.addZero(num2, digitNumber);
            let new_val2 = this.addZero(num3, digitNumber);
            this.allText[updateTarget] = {
                id: this.allText[updateTarget].id,
                mode: "generate",
                text: newTxt || "",
                text2: new_val || "",
                text3: new_val2 || "",
            }
            this.renderText();
        },
        removeInput(id) {
            this.input = this.input.filter((item) => item.id != id)
            this.allText = this.allText.filter((item) => item.id != id)
            this.test = "";
            this.test2 = "";
            this.test3 = "";
            this.renderText();
        },
        addZero(num, digitNumber) {
            var txtVal = "";
            var zeroTxt = "";
            var newDigit = digitNumber.toString().length - 1;
            if (num.toString().length == newDigit) {
                txtVal = num.toString();
            } else {
                for (
                    var digitCount = num.toString().length;
                    digitCount < newDigit;
                    digitCount++
                ) {
                    zeroTxt = zeroTxt + "0";
                }
                txtVal = zeroTxt + num.toString();
            }
            return txtVal;
        },
        renderText() {
            for (var k = 0; k < this.allText.length; k++) {
                this.test = this.test + this.allText[k].text;
                this.test2 = this.test2 + this.allText[k].text2;
                this.test3 = this.test3 + this.allText[k].text3;
            }
        },
        create_id() {
            this.dialog = false;
            this.$emit("updateListId", this.allText);
            this.$emit("toggleFetchStudent");
        },
    },
    watch: {
        // whenever question changes, this function will run
        dialogBool() {
            this.dialog = true;
        },
        input_id() {
            if (this.input.length > 4) {
                document.querySelector("#add-type").style.color =
                    "rgb(175, 173, 177)";
                document.querySelector("#add-type").style.cursor = "default";
            } else {
                document.querySelector("#add-type").style.color = "orange";
                document.querySelector("#add-type").style.cursor = "pointer";
            }
        },
    },
};
</script>